import(/* webpackMode: "eager", webpackExports: ["PostSingle"] */ "/vercel/path0/src/components/single/post.tsx");
